import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import api from '../../services/api';

export interface Client {
  id: number;
  name: string;
  cnpj: string;
}

const Clients: React.FC = () => {
  const [clients, setClients] = useState<Client[]>();

  useEffect(() => {
    api.get('user-clients-list').then(response => {
      setClients(response.data);
    });
  }, []);

  return (
    <>
      <div className="row">
        <div className="col">
          <h5>CLIENTES</h5>
        </div>
        <div className="col text-right">
          <Link to="/dashboard/" className="btn btn-default btn-sm mr-2">
            Voltar
          </Link>
          <Link to="/clients/register" className="btn btn-primary btn-sm">
            Cadastrar novo
          </Link>
        </div>
      </div>

      <div className="form-group head-text">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas
          molestie elit vitae varius maximus. Nullam metus enim, sagittis
          maximus quam placerat, fermentum convallis elit. Nulla facilisi. Cras
          rutrum nunc sapien, tristique maximus nulla scelerisque in. Vestibulum
          nec neque sit amet arcu rutrum laoreet.
        </p>
      </div>

      {clients && clients.length ? (
        <div className="table-responsive">
          <table className="table" width="100%">
            <thead>
              <tr>
                <th>NOME</th>
                <th>CNPJ</th>
              </tr>
            </thead>
            <tbody>
              {clients.map(client => (
                <tr key={client.id}>
                  <td>{client.name}</td>
                  <td>{client.cnpj}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div>
          {clients && clients.length === 0 ? (
            <div>Nenhum resultado encontrado.</div>
          ) : (
            <div>Pesquisando, aguarde...</div>
          )}
        </div>
      )}
    </>
  );
};

export default Clients;
